import React, { Component } from 'react';
import { connect } from 'react-redux';
import onClickOutside from 'react-onclickoutside';

import A from '../../../Anchor/Anchor';
import Link from '../../../Link/Link';
import CartIcon from '../../../Icons/headerIcons/CartIcon';
import { FaCheck } from 'react-icons/fa';

import {
  updateCartQuantity,
  removeFromCart,
  getMaxAddable,
  getCartTotalDiscountable,
  getCartTotalDiscountedCoupon,
} from '../../../../../redux/modules/cart';

import { primary_s5_l70_a015, primary_s20_l70_a025 } from '../../../lib/colors';
import { css } from '@emotion/core';

import { removeFromCartEvent } from '../../../lib/gaEnhancedEcommerce';

import Price from '../../../Price/Price';
import SingleCartItem from './SingleCartItem/SingleCartItem';
import Threshold from '../../../Threshold/Threshold';
import FidelityPoint from '../../../FidelityPoint/FidelityPoint';

import './CartMenu.scss';
import {
  ga4AddToCart,
  ga4RemoveFromCart,
  ga4ViewCart,
} from '../../../lib/ga4EnhancedEcommerce';
import {
  fkmxAddToCart,
  fkmxRemoveFromCart,
  fkmxViewCart,
} from '../../../lib/farmakomMetrics';
import BagIcon from '../../../Icons/headerIcons/BagIcon';
import { getShippingCost } from '../../../../../redux/modules/checkout';
import {
  setCoupon,
  resetCoupon,
  getCoupon,
  isValidCoupon,
} from '../../../../../redux/modules/checkout';
import { ImageDispatcher } from '../../../ImageDispatcher/ImageDispatcher';

const calculateCartTotal = cart => {
  return cart.reduce((total, product) => {
    return total + product.price * product.quantity;
  }, 0);
};

const calculateCartQuantity = cart => {
  return cart.reduce((total, product) => {
    return total + product.quantity;
  }, 0);
};

class CartMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponCode: '',
    };
  }

  componentDidMount() {
    if (localStorage.getItem('cartId')) {
      this.props.getShippingCost(
        localStorage.getItem('cartId'),
        this.props.user.data.shipping.zipcode,
        this.props.user.data.shipping.country
      );
    }
    this.setState({ couponCode: localStorage.getItem('coupon') });
  }

  componentDidUpdate(oldProps) {
    if (
      this.props.showCartMenu !== oldProps.showCartMenu &&
      !!this.props.showCartMenu
    ) {
      if (this.props.hasGoogleAnalytics4Advanced) {
        // GA4 VIEW CART
        ga4ViewCart(
          this.props.cart,
          this.props.cart.reduce((total, product) => {
            return total + product.price * product.quantity;
          }, 0)
        );
      }
      if (this.props.hasFarmakomMetrics) {
        // FKMX VIEW CART
        fkmxViewCart(
          this.props.cart,
          this.props.cart.reduce((total, product) => {
            return total + product.price * product.quantity;
          }, 0)
        );
      }
    }
    if (
      this.props.cart.length !== oldProps.cart.length ||
      calculateCartQuantity(this.props.cart) !==
        calculateCartQuantity(oldProps.cart) ||
      calculateCartTotal(this.props.cart) !== calculateCartTotal(oldProps.cart)
    ) {
      if (localStorage.getItem('cartId')) {
        this.props.getShippingCost(
          localStorage.getItem('cartId'),
          this.props.user.data.shipping.zipcode,
          this.props.user.data.shipping.country
        );
      }
    }
  }

  handleClickOutside = event => {
    let { onCloseCartMenu } = this.props;

    return onCloseCartMenu(event);
  };

  decrement = product => event => {
    event.preventDefault();
    if (product.quantity > 1) {
      this.props.updateCartQuantity(product.id, product.quantity - 1);
    }
    // GA4 REMOVE FROM CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4RemoveFromCart({ ...product, quantity: 1 });
    }
    // FKMX REMOVE FROM CART
    if (this.props.hasFarmakomMetrics) {
      fkmxRemoveFromCart({ ...product, quantity: 1 });
    }
  };

  increment = product => event => {
    event.preventDefault();

    const maxAddable = getMaxAddable(this.props.globalState, product);
    const { minNumInCart } = product;

    if (maxAddable > 0) {
      // Posso aggiungere al carrello
      let newQuantity = product.quantity + 1;

      // Se c'è una quantità minima carrello e non l'ho raggiunta
      if (minNumInCart && product.quantity < minNumInCart) {
        // La nuova quantità è il minimo tra
        // la quantità minima carrello e il numero
        // massimo di pezzi che possono stare nel carrello
        newQuantity = Math.min(minNumInCart, maxAddable + product.quantity);
      }

      // Applico nuova quantità
      this.props.updateCartQuantity(product.id, newQuantity);

      // GA4 ADD TO CART
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4AddToCart({ ...product, quantity: 1 });
      }
      // FKMX ADD TO CART
      if (this.props.hasFarmakomMetrics) {
        fkmxAddToCart({ ...product, quantity: 1 });
      }
    }
  };

  removeFromCart = product => event => {
    event.preventDefault();
    this.props.removeFromCart(product);

    if (this.props.advancedGa) {
      removeFromCartEvent({
        id: product.code || '',
        name: product.name,
        category: product.categoryName,
        brand: product.brand,
        price: product.price,
        quantity: product.quantity,
      });
    }

    // GA4 REMOVE FROM CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4RemoveFromCart(product);
    }

    // FKMX REMOVE FROM CART
    if (this.props.hasFarmakomMetrics) {
      fkmxRemoveFromCart(product);
    }
  };

  renderCartItems() {
    const { primaryColor, uiVariantButton } = this.props;

    return this.props.cart
      .sort((a, b) => a.id - b.id)
      .map(product => {
        return (
          <SingleCartItem
            key={product.id}
            product={product}
            onIncrement={this.increment(product)}
            onDecrement={this.decrement(product)}
            onRemove={this.removeFromCart(product)}
            primaryColor={primaryColor}
            uiVariantButton={uiVariantButton}
          />
        );
      });
  }

  renderCartTotal() {
    return this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
  }

  renderCartItemsQuantity() {
    return this.props.cart.reduce((total, product) => {
      return total + product.quantity;
    }, 0);
  }

  handleApplyCoupon = () => {
    const { couponCode } = this.state;

    if (!!couponCode) {
      this.props.setCoupon(couponCode);

      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('coupon', couponCode);
      }

      if (couponCode.length > 2) {
        this.props.getCoupon(couponCode);
      }
    }
  };

  handleResetCoupon = () => {
    this.setState({ couponCode: '' });
    this.props.resetCoupon();
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('coupon');
    }
  };

  renderCouponWarning = () => {
    if (
      !this.props.couponIsAppliedToSopOtc &&
      this.props.coupon.minAmount &&
      this.props.cart.every(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      )
    ) {
      return (
        <div className="coupon-warning">
          Per normativa il coupon <b>NON</b> può essere applicato a farmaci e
          omeopatici.
        </div>
      );
    } else if (
      !this.props.couponIsAppliedToSopOtc &&
      this.props.coupon.minAmount &&
      this.props.cart.some(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      )
    ) {
      return (
        <div className="coupon-warning">
          Per normativa il coupon non sarà applicato a farmaci e omeopatici, ma{' '}
          <b>SOLO</b> ai parafarmaci.
        </div>
      );
    } else if (
      !this.props.coupon.loading &&
      this.props.coupon.minAmount > 0 &&
      this.props.cartTotalDiscountable < this.props.coupon.minAmount
    ) {
      return (
        <div className="coupon-warning">
          Aggiungi ancora{' '}
          <b>
            {Math.round(
              (this.props.coupon.minAmount - this.props.cartTotalDiscountable) *
                100
            ) / 100}{' '}
            €
          </b>{' '}
          per attivare il coupon.
        </div>
      );
    }
  };

  renderCouponButton = () => {
    const { validCoupon } = this.props;

    if (validCoupon) {
      return (
        <button
          style={{ backgroundColor: '#fc8080' }}
          className="custom-button"
          onClick={this.handleResetCoupon}
        >
          Rimuovi
        </button>
      );
    } else {
      return (
        <button className="custom-button" onClick={this.handleApplyCoupon}>
          Attiva
        </button>
      );
    }
  };

  renderCartMenu() {
    const {
      cart,
      validCoupon,
      onCloseAll,
      shippingCost,
      freeShippingThreshold,
      cartTotalDiscounted,
      coupon,
      hasFidelityCard,
    } = this.props;

    const freeShippingPrice = Math.max(
      0,
      freeShippingThreshold - this.renderCartTotal()
    );

    const formattedDiscount = coupon.discount.toFixed(2).replace('.', ',');

    if (cart && cart.length > 0) {
      return (
        <div
          className="cart-menu"
          style={cart.length > 0 ? { minHeight: '82vh' } : ''}
        >
          <div className="cart-head">
            <p className="cart-name">Carrello</p>
            <div className="frame" onClick={onCloseAll}>
              <ImageDispatcher
                className="icon"
                alt="Icon"
                src="/static/images/icone-v3/close-button.svg"
              />
            </div>
          </div>
          <Threshold
            threshold={freeShippingThreshold}
            subTotal={this.renderCartTotal()}
            shippingCost={shippingCost}
          />

          <div className="cart-coupon">
            <div className="input-with-button">
              {validCoupon && (
                <div className="promo-check coupon-check">
                  <FaCheck />
                </div>
              )}
              <input
                type="text"
                className="form-control"
                placeholder="Hai un codice coupon?"
                value={
                  typeof this.state.couponCode !== 'undefined'
                    ? this.state.couponCode
                    : this.props.coupon.code
                }
                onChange={e => this.setState({ couponCode: e.target.value })}
                disabled={validCoupon}
              />
              {this.renderCouponButton()}
            </div>
          </div>
          <div className="cart-render-warning">
            {this.renderCouponWarning()}
          </div>

          <div className="cart-menu-items">{this.renderCartItems()}</div>
          <hr />
          <div>
            <div className="det subTotal" style={{ marginTop: '1rem' }}>
              <span className="text">Subtotale:</span>
              <span className="amount">
                €{' '}
                {this.renderCartTotal()
                  .toFixed(2)
                  .replace('.', ',')}
              </span>
            </div>
          </div>
          <div>
            <div className="det shipping">
              <span className="text">Spedizione:</span>
              <span className="amount">
                {freeShippingPrice === 0
                  ? 'Gratuita'
                  : `€ ${shippingCost.toFixed(2).replace('.', ',')}`}
              </span>
            </div>
          </div>
          {validCoupon && (
            <div>
              <div className="det couponDiscount">
                <span className="text">Coupon:</span>
                <span className="amount">€ -{formattedDiscount}</span>
              </div>
            </div>
          )}
          <div className="total" style={{ display: 'flex' }}>
            <span className="text">Totale:</span>
            <span className="amount">
              <Price
                amount={
                  freeShippingPrice === 0
                    ? cartTotalDiscounted
                    : cartTotalDiscounted + shippingCost
                }
              />
            </span>
          </div>
          <div className="cart-checkout">
            <Link
              to="/carrello"
              className="btn btn-primary"
              onClick={onCloseAll}
            >
              Vai al carrello
            </Link>
          </div>
          {!!hasFidelityCard && (
            <div className="fidelity-point">
              <FidelityPoint borderRatio="16px" />
            </div>
          )}
        </div>
      );
    }

    // Else, no products in cart
    return (
      <div className="cart-menu">
        <div className="total">Non ci sono articoli nel carrello</div>
      </div>
    );
  }

  render() {
    const {
      showCartMenu,
      onToggleCartMenu,
      primaryColor,
      headerMenuVersion,
      isMobile,
    } = this.props;

    const cartMenuStyle = css`
      &.menu-open .cart-menu:after {
        border-bottom-color: ${primary_s20_l70_a025(primaryColor)}!important;
      }
      .cart-menu {
        border-color: ${primary_s5_l70_a015(primaryColor)}!important;
        box-shadow: 0px 0px 48px 24px rgba(0, 0, 0, 0.2);
      }
      a > .cart {
        display: flex;
        align-items: center;
        gap: 8px;
        position: relative;

        &:focus,
        &:hover {
          text-decoration: none;
        }
        & p {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 0px;
        }
        & svg {
          width: 20px;
          height: 20px;

          path {
            fill: ${primaryColor};
          }
        }
        & span {
          color: #fffff;
        }
      }
      a > .cart.v1 {
        svg {
          @media screen and (max-width: $screen-md) {
            width: 15px;
            height: 14px;
          }
          path {
            fill: #19165a;
          }
        }
      }
    `;

    return (
      <div
        className={`open-cart-menu ${showCartMenu ? 'menu-open' : ''}`}
        css={cartMenuStyle}
      >
        {isMobile ? (
          <A href="/carrello" aria-label="Guarda il tuo carello">
            {headerMenuVersion === 1 ? (
              <div className="cart v1">
                <CartIcon />
                <span className="badge">{this.renderCartItemsQuantity()}</span>
                <p>Carrello</p>
              </div>
            ) : (
              <div className="cart">
                <BagIcon />
                <span className="badge">{this.renderCartItemsQuantity()}</span>
              </div>
            )}
          </A>
        ) : (
          <A
            href="#"
            onClick={onToggleCartMenu}
            aria-label="Guarda il tuo carello"
          >
            {headerMenuVersion === 1 ? (
              <div className="cart v1">
                <CartIcon />
                <span className="badge">{this.renderCartItemsQuantity()}</span>
                <p>Carrello</p>
              </div>
            ) : (
              <div className="cart">
                <BagIcon />
                <span className="badge">{this.renderCartItemsQuantity()}</span>
              </div>
            )}
          </A>
        )}

        {!this.props.isMobile && this.renderCartMenu()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    cart: state.cart,
    user: state.user,
    coupon: state.checkout.coupon,
    advancedGa: state.store.data.features.advancedGa,
    globalState: state,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    freeShippingThreshold:
      state.checkout.shippingAbroadThreshold ||
      state.store.data.costiSpedizione.freeShippingThreshold,
    shippingCost: state.checkout.shippingCost,
    couponIsAppliedToSopOtc:
      state.store.data.funzionalita.couponIsAppliedToSopOtc,
    cartTotalDiscountable: getCartTotalDiscountable(state),
    cartTotalDiscounted: getCartTotalDiscountedCoupon(state),
    validCoupon: isValidCoupon(state),
    hasFidelityCard: state.store.data.features.hasFidelityCard,
  };
}

export default connect(mapStateToProps, {
  updateCartQuantity,
  getShippingCost,
  removeFromCart,
  getCoupon,
  setCoupon,
  resetCoupon,
})(onClickOutside(CartMenu));
